import {apiHttp, defHttp} from '/@/utils/http/axios';
import {LoginParams, LoginResultModel} from './model/userModel';

import {ErrorMessageMode} from '/#/axios';
import {UserInfo} from "/#/store";

enum Api {
    Login = '/login',
    GetPermCode = '/getPermCode',
    // 退出
    POST_LOGOUT = '/__common/auth/logout.do',
    // 注销
    POST_LOGOFF = '/acct/close',
    // 获取用户信息
    // GET_USERINFO = '/__common/auth/userInfo.do',
    GET_USERINFO = '/employee/userDetail',
    // 获取购物车商品数量
    GET_CART_GOODS_NUM = '/index/cartGoodsNum',
    // 获取购物车商品数量
    GET_CURRENT_USER_STATUS = '/employee/getCurrentUserStatus',
}

/**
 * 获取用户状态信息
 */
export function getCurrentUserStatus() {
    return apiHttp.get({
        url: Api.GET_CURRENT_USER_STATUS
    })
}

/**
 * 获取购物车商品数量
 */
export function getCartGoodsNum() {
    return apiHttp.get({
        url: Api.GET_CART_GOODS_NUM
    })
}

// /**
//  * 获取未读消息数
//  */
// export function getUnReadMsgCount() {
//   return apiHttp.get({
//     url: Api.GET_UN_READ_MSG_COUNT
//   })
// }


/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
    return defHttp.post<LoginResultModel>(
        {
            url: Api.Login,
            params,
        },
        {
            errorMessageMode: mode,
        },
    );
}


export const getUserInfo = (params) =>
    apiHttp.get<UserInfo>({
        url: Api.GET_USERINFO,
        params,
    });

export function getPermCode() {
    return defHttp.get<string[]>({url: Api.GetPermCode});
}

export function doLogout(params) {
    return apiHttp.post({
        url: Api.POST_LOGOUT,
        params
    });
}

export function doLoOff() {
    return apiHttp.post({url: Api.POST_LOGOFF});
}
